var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyString(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_595_44642)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_595_44642)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_595_44642",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_595_44642)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_595_44642",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_595_44642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2633 18.7094H8.92998C8.60844 18.7099 8.28994 18.6471 7.99272 18.5244C7.6955 18.4017 7.42538 18.2217 7.19782 17.9945C6.97026 17.7673 6.78973 17.4975 6.66656 17.2005C6.54338 16.9035 6.47998 16.5851 6.47998 16.2635V8.93021C6.47998 8.28153 6.73767 7.65943 7.19635 7.20074C7.65503 6.74206 8.27714 6.48438 8.92581 6.48438H16.2591C16.9078 6.48438 17.5299 6.74206 17.9886 7.20074C18.4473 7.65943 18.705 8.28153 18.705 8.93021V16.2635C18.705 16.9115 18.4479 17.533 17.9901 17.9915C17.5323 18.4501 16.9113 18.7083 16.2633 18.7094ZM8.92998 8.11104C8.71383 8.11104 8.50653 8.19691 8.35369 8.34975C8.20085 8.50259 8.11498 8.70989 8.11498 8.92604V16.2594C8.11498 16.3664 8.13606 16.4724 8.17702 16.5713C8.21798 16.6701 8.27801 16.76 8.35369 16.8357C8.42937 16.9113 8.51921 16.9714 8.61809 17.0123C8.71697 17.0533 8.82295 17.0744 8.92998 17.0744H16.2633C16.3703 17.0744 16.4763 17.0533 16.5752 17.0123C16.6741 16.9714 16.7639 16.9113 16.8396 16.8357C16.9153 16.76 16.9753 16.6701 17.0163 16.5713C17.0572 16.4724 17.0783 16.3664 17.0783 16.2594V8.92604C17.0783 8.70989 16.9924 8.50259 16.8396 8.34975C16.6868 8.19691 16.4795 8.11104 16.2633 8.11104H8.92998Z",
    fill: "#9196AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55258 13.5213H3.73758C3.41639 13.5213 3.09835 13.458 2.8016 13.3351C2.50486 13.2122 2.23523 13.0321 2.00812 12.8049C1.781 12.5778 1.60084 12.3082 1.47793 12.0114C1.35501 11.7147 1.29175 11.3967 1.29175 11.0755V3.74214C1.29131 3.42066 1.35425 3.10226 1.47697 2.80513C1.59969 2.508 1.77978 2.23798 2.00694 2.01051C2.2341 1.78305 2.50387 1.60259 2.80083 1.47947C3.09779 1.35634 3.41611 1.29297 3.73758 1.29297H11.0709C11.7196 1.29297 12.3417 1.55065 12.8004 2.00934C13.2591 2.46802 13.5167 3.09013 13.5167 3.7388V4.5538C13.5167 4.77006 13.4308 4.97747 13.2779 5.13039C13.125 5.28331 12.9176 5.36922 12.7013 5.36922C12.4851 5.36922 12.2777 5.28331 12.1247 5.13039C11.9718 4.97747 11.8859 4.77006 11.8859 4.5538V3.7388C11.8859 3.52265 11.8001 3.31535 11.6472 3.16251C11.4944 3.00967 11.2871 2.9238 11.0709 2.9238H3.73758C3.52143 2.9238 3.31413 3.00967 3.16129 3.16251C3.00845 3.31535 2.92258 3.52265 2.92258 3.7388V11.0721C2.92258 11.2883 3.00845 11.4956 3.16129 11.6484C3.31413 11.8013 3.52143 11.8871 3.73758 11.8871H4.55258C4.65967 11.8871 4.7657 11.9082 4.86463 11.9492C4.96356 11.9902 5.05345 12.0502 5.12917 12.126C5.20489 12.2017 5.26495 12.2916 5.30593 12.3905C5.34691 12.4894 5.368 12.5955 5.368 12.7026C5.368 12.8096 5.34691 12.9157 5.30593 13.0146C5.26495 13.1135 5.20489 13.2034 5.12917 13.2791C5.05345 13.3549 4.96356 13.4149 4.86463 13.4559C4.7657 13.4969 4.65967 13.518 4.55258 13.518V13.5213Z",
    fill: "#9196AF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_595_44642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_595_44642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyString);
export default __webpack_public_path__ + "static/media/copyString.84a9ddc1ad0074c8ac5fd88521445ca8.svg";
export { ForwardRef as ReactComponent };